import { useEffect } from 'react';
import debounce from 'lodash.debounce';
import { useAttributeSearch } from '../../../hooks/useAttributeSearch';

interface ZoomToAttributeSearchProps {
  topicId: string;
  callback?: () => void;
}

const ZoomToAttributeSearch = ({ topicId, callback }: ZoomToAttributeSearchProps) => {
  const { attributesQuery, zoomToFeatures } = useAttributeSearch(topicId);
  useEffect(() => {
    if (!attributesQuery.data) return () => {};

    const debouncedSetLocation = debounce(() => {
      zoomToFeatures();
      callback?.();
    }, 500);

    debouncedSetLocation();

    return () => debouncedSetLocation.cancel();
  }, [attributesQuery.data]);

  return null;
};

export default ZoomToAttributeSearch;
